// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.57.0',
  commit: 'bf965f487724b25f72f74c003fc623d933c56914',
  branch: 'feature/APA-3874-keycloack',
  dateGenerated: '2025-12-09T11:26:13.839Z',
};